import PropTypes from "prop-types";
import React from "react";

const HeaderDetails = ({ descriptions }) => {
  return (
    <div className="mb-5">
      <div className="view-title table-title">
        <h4>Header Descriptions</h4>
      </div>
      {descriptions?.map((item, index) => (
        <div className="view-employee-content" key={index}>
          <ul className="list-unstyled">
            <li>
              <h6>{item?.description}</h6>
            </li>
          </ul>
        </div>
      ))}
    </div>
  );
};

export default React.memo(HeaderDetails);

HeaderDetails.propTypes = {
  descriptions: PropTypes.array,
};
